import React from 'react';
import './CtaSection.scss';

const CtaSection = () => {
  return (
    <div className="unfm-cta">
      <section className="cta">
        <div className="cta__container">
          <h2 className="cta__title">Prête à démarrer votre parcours&nbsp;?</h2>

          <p className="cta__subtitle">
            Que vous soyez une femme en recherche d&apos;orientation, un
            assistant social, une association ou un formateur, UNFM 2.0
            vous accompagne à chaque étape.
          </p>

          <div className="cta__actions">
            <a href="/orientation" className="cta__btn cta__btn--solid">
              Faire ma demande d&apos;orientation
            </a>
            <a
              href="/espace-professionnel"
              className="cta__btn cta__btn--outline"
            >
              Accéder à mon espace professionnel
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CtaSection;